<template>
  <div class="bg-white top-0 z-40 left-0 duration-200 h-full shadow-md w-[60px] flex flex-col p-1 py-3 items-center"
    :class="!sideNavOpen ? '-translate-x-[100%] absolute' : 'relative'">
    <button
      class="bg-primary-main rounded-sm absolute -right-10 top-5 !shadow-2xl text-white h-10 w-10 grid place-items-center"
      @click="handleCollapse">
      <Icon icon="ant-design:menu-fold-outlined" class="text-xl" />
    </button>
    <router-link :to="'/dashboard/documents'" @click="clearAnalysis" class="mt-3">
      <v-progress-circular v-if="loadingBrainResponse" :size="50" :width="4" color="primary-dark" indeterminate>
        <figure class="mx-auto aspect-square w-[40px]">
          <img src="@/assets/images/logo--small.png" alt="Logo" class="w-full h-full object-contain" />
        </figure>
      </v-progress-circular>
      <figure v-if="!loadingBrainResponse" class="mx-auto aspect-square w-[40px]">
        <img src="@/assets/images/logo--small.png" alt="Logo" class="w-full h-full object-contain" />
        <v-tooltip activator="parent" location="end">Dashboard</v-tooltip>
      </figure>
    </router-link>
    <router-link :to="'/dashboard/account'">
      <button class="bg-primary-main rounded-full text-white h-10 w-10 mt-10 grid place-items-center"
        @click="clearAnalysis">
        <Icon icon="ant-design:user" class="text-xl" />
        <v-tooltip activator="parent" location="end">My Profile</v-tooltip>
      </button>
    </router-link>

    <div class="grid gap-2 mt-auto content-start">
      <div
        class="cursor-pointer hover:!text-primary-main hover:bg-primary-light duration-200 p-3 grid place-items-center border-transparent"
        active-class="border-primary-main !text-primary-main bg-primary-light"
        @click="openReferral()"
      >
        <Icon :icon="'ant-design:dollar-outlined'" class="text-xl" />
        <v-tooltip activator="parent" location="end">Referral Program</v-tooltip>
      </div>
      <div
        class="cursor-pointer hover:!text-primary-main hover:bg-primary-light duration-200 p-3 grid place-items-center border-transparent"
        active-class="border-primary-main !text-primary-main bg-primary-light"
        @click="openTutorials()"
      >
        <Icon :icon="'ant-design:play-square-outlined'" class="text-xl" />
        <v-tooltip activator="parent" location="end">Tutorials</v-tooltip>
      </div>
      <div
        class="cursor-pointer hover:!text-primary-main hover:bg-primary-light duration-200 p-3 grid place-items-center border-transparent"
        @click="openUrl(webBaseUrl + '/contact-writewise/')"
        active-class="border-primary-main !text-primary-main bg-primary-light">
        <Icon :icon="'ant-design:customer-service'" class="text-xl" />
        <v-tooltip activator="parent" location="end">Support</v-tooltip>
      </div>
      <TlPopConfirm :title="'Are you sure you want to logout?'" :okText="'Yes, Logout'" :cancelText="'No'"
        :placement="'rightBottom'" @confirm="logout">
        <div class="cursor-pointer hover:!text-red-500 hover:bg-red-200 duration-200 p-3 grid place-items-center">
          <Icon :icon="'ant-design:poweroff-outlined'" class="text-xl" />
          <v-tooltip activator="parent" location="end">Logout</v-tooltip>
        </div>
      </TlPopConfirm>
    </div>
    <Tutorials v-model="isTutorials" />
    <Referral v-model="isReferral" />
    <!-- <Affiliation /> -->
  </div>
</template>

<script lang="ts">
import { Icon } from '@iconify/vue';
import { extraSideNavLinks } from '@/utils/homeLinks';
import { Prop } from 'vue-property-decorator';
import TlPopConfirm from '@/components/global/TlPopConfirm.vue';
import { Vue, Options } from 'vue-class-component';
import { logout } from '@/actions/auth';
import { usePayloadStore } from '@/stores/payload';
import { Popconfirm } from 'ant-design-vue/lib';
import 'ant-design-vue/lib/popconfirm/style/css';
import { Watch } from 'vue-property-decorator';
import Tutorials from '@/components/global/Tutorials.vue';
import Referral from '@/components/global/Referral.vue';
import Affiliation from '@/components/global/Affiliation.vue';
@Options({
  components: {
    Icon,
    TlPopConfirm,
    Tutorials,
    Referral,
    Affiliation
  }
})
export default class SideNav extends Vue {
  @Prop()
  public sideNavOpen!: boolean;
  public loadingResponse: boolean = false;
  public loadingBrainResponse: boolean = false;
  public extraSideNavLinks: any = extraSideNavLinks;
  public webBaseUrl = process.env.WEB_BASE_URL;
  public handleCollapse() {
    this.$emit('closeSideNav');
  }

  private payloadStore = usePayloadStore();

  mounted() {
    this.loadingBrainResponse = this.payloadStore.payload.loadingBrainResponse;
  }

  @Watch('payloadStore.payload')
  public onLoadingBrainResponse() {
    this.loadingBrainResponse = this.payloadStore.payload.loadingBrainResponse;
  }

  public logout = () => {
    this.payloadStore.change({ loadingResponse: true });
    logout()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((res: any) => {
        this.payloadStore.change({ loadingResponse: false });
        this.payloadStore.clear();
        window.location.href = '/accounts/login/';
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((err: any) => {
        this.payloadStore.change({ loadingResponse: false });
        this.payloadStore.clear();
        window.location.href = '/accounts/login/';
      });
  };

  public openUrl(url: string) {
    (window.open(url, '_blank') as any).focus();
  }

  public isTutorials = false;
  public openTutorials() {
    this.isTutorials = true;
  }

  public isReferral = false;
  public openReferral() {
    this.isReferral = true;
  }
  
  public clearAnalysis() {
    const tooltip = document.querySelector('quill-oai-popup');
    if (tooltip) {
      tooltip.remove();
    }
  }
}
</script>
<style>
/* apply styles to the pop confirm container */
.ant-popover-inner {
  border-radius: 15px;
}
</style>
